@let config = filterConfig();
@let filterFormControlValue = formControl()?.value;

<cap-dynamic-filter-layout
  class="dynamic-date-time-range-filter"
  [label]="config.showLabel ? config.label : ''"
  [iconClass]="config.icon"
  [showReset]="filterFormControlValue && (config.resetFilter ?? true)"
  (resetFilter)="reset()">
  @if (!config.disabled) {
    <div class="dynamic-date-time-range-filter-input" (click)="toggle($event)">
      <span class="input-value">
        @if (filterFormControlValue) {
          @for (date of filterFormControlValue.date | dateRangeArray: config.selectionMode || 'range'; track $index) {
            {{ date | date: 'dd-MM-yyyy' }}

            @if (!$last) {
              &nbsp;-&nbsp;
            }
          }

          {{ filterFormControlValue.from }} - {{ filterFormControlValue.to }}
        } @else {
          {{ config.placeholder }}
        }
      </span>
    </div>
  }
</cap-dynamic-filter-layout>

<p-popover #dateTimeRangePicker [appendTo]="'body'" [styleClass]="'date-time-range-filter-popover-wrapper'">
  <div class="date-time-range-filter-popover" [formGroup]="formGroup">
    <div class="date-inputs">
      <input
        type="date"
        class="date-input"
        [value]="dateInputs().from"
        [attr.min]="minInput() || null"
        [attr.max]="maxInput() || null"
        (change)="onDateInput(0, $event)" />

      @if (config.selectionMode === 'range') {
        <i class="mynaui-arrow-right"></i>

        <input
          type="date"
          class="date-input"
          [value]="dateInputs().to"
          [attr.min]="minInput() || null"
          [attr.max]="maxInput() || null"
          (change)="onDateInput(1, $event)" />
      }
    </div>

    <div class="date-picker">
      <p-date-picker
        [inline]="true"
        formControlName="date"
        [selectionMode]="filterConfig().selectionMode"
        [maxDate]="maxDate()"
        [minDate]="minDate()"
        (onSelect)="onDateSelect()" />
    </div>
    <div class="time-picker">
      <div class="time-picker-box from-time">
        <p-date-picker [timeOnly]="true" formControlName="from" (onBlur)="checkFromToTime('from')" />
      </div>
      <div class="separator">
        <i class="mynaui-arrow-right"></i>
      </div>
      <div class="time-picker-box to-time">
        <p-date-picker [timeOnly]="true" formControlName="to" (onBlur)="checkFromToTime('to')" />
      </div>

      <i class="clickable mynaui-undo reset-time" (click)="resetTime()"></i>
    </div>

    <div class="actions">
      <cap-button styleClass="primary btn-sm" [label]="'apply.button' | translate" (onClick)="apply()" />
    </div>
  </div>
</p-popover>
